import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { useLegalForUse } from "./hook";

export const LegalForUse: React.FC = () => {
  const { query } = useLegalForUse();

  return (
    <Container>
      <TitleWrapper id="term_of_service">
        <Title>利用規約</Title>
      </TitleWrapper>
      <Caption>
        株式会社ジョイフル（以下「当社」といいます。）は、当社が運営するWebサイト（以下、「本サイト」といいます。）を利用して、お客様より当社の店舗で提供する商品の注文を受け、商品を提供するサービス（以下、「本サービス」といいます。）の利用について、以下のとおり定めます（以下、「本規約」といいます）。
      </Caption>

      <Article>
        <ArticleHeader>第１条（本規約の適用範囲及び変更）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  本規約は、当社、当社による本サービスの提供並びにお客様による本サービスの利用に関し、本規約にご同意いただいた上、会員登録をされたお客様（以下、「会員」といいます。）との間に適用されるものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  当社は、会員への事前の通知をすることなく、本サイトに本規約を変更した旨記載することにより、本規約を変更できるものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  当社は、本規約を変更した場合には、本サイトにおいて当該変更内容を掲示するものとし、会員は、当該変更後の本規約に従うものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第２条（本サービスの提供及び利用）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  当社は、本規約及び当社が別途定める規定に従い、本サービスを提供するものとし、会員は、本規約及び当社が別途定める規定に従い、本サービスを利用するものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  当社は、株式会社unerry（東京都港区虎ノ門1丁目17番1号
                  虎ノ門ヒルズビジネスタワー
                  15階。以下、「unerry」といいます。）に、本サービスの提供の一部を委託して、本サービスを運営します。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  当社は、会員に事前に通知をすることなく、本サービスの内容を変更又は終了することができるものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第３条（利用環境等）</ArticleHeader>
        <ArticleContent>
          <Text>
            会員による本サービスの利用料は無料とします。ただし、本サービスの利用（サポート対応等を含む。）に伴い発生する通信のための費用又は電話料金及び注文にかかる商品代金は会員にご負担いただきます。また、本サービスの利用に必要な機器及びシステムについては、会員の費用と責任においてご準備いただきます。
          </Text>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>第４条（会員登録）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  本サービスを初めてご利用になる場合、本サービスの会員登録が必要となります。お客様が会員登録を希望される場合、会員登録ページから当社の指定する方法に従い会員登録申込みを行うものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  当社は、前項の申込みに対し、登録確認メールを送信することにより申込みに対する当社による承諾を行うものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  申込者が、本規約の違反などにより過去に会員登録の抹消処分を受けていることが判明した場合、会員登録申込者の申込内容に虚偽の事項が含まれている場合、その他登録申込みを承認することが不適当であると当社が判断する場合には、当該登録申込みを承認しない場合があります。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第５条（変更の届出）</ArticleHeader>
        <ArticleContent>
          <Text>
            会員は、その氏名、電話番号、メールアドレスその他会員登録に際して届け出た事項に変更が生じた場合には、当社が別途指定する方法により届け出るものとします。
          </Text>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>
          第６条（本サービスの提供停止、会員登録の抹消）
        </ArticleHeader>
        <ArticleContent>
          <Text>
            当社は、会員が以下の各号のいずれか一つにでも該当する場合、会員に事前の通知をすることなく本サービスの提供の停止又は会員登録の抹消を行うことができるものとします。
          </Text>
        </ArticleContent>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="num">（1）</td>
                <td className="info">
                  本規約の違反などにより過去に会員登録の抹消処分を受けていることが判明した場合
                </td>
              </tr>
              <tr>
                <td className="num">（2）</td>
                <td className="info">
                  本サービスに関する料金の支払債務又は商品の受領義務の不履行があった場合
                </td>
              </tr>
              <tr>
                <td className="num">（3）</td>
                <td className="info">第１１条の禁止事項の行為を行った場合</td>
              </tr>
              <tr>
                <td className="num">（4）</td>
                <td className="info">第１２条の遵守事項等に違反した場合</td>
              </tr>
              <tr>
                <td className="num">（5）</td>
                <td className="info">その他本規約に違反した場合</td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>
          第７条（商品の購入及び申込のキャンセルについて）
        </ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  会員は、本サービスを利用して当社の商品を注文することができます。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  会員は、当社の商品の注文を希望する場合、当社が指定する方法に従って商品の注文を申込むものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  前項の申込みに対して、当社より承諾する旨のメールを会員宛に発信し到達した時点で、会員と当社との間に当該商品などに関する売買契約が成立するものとします。
                </td>
              </tr>
              <tr>
                <td className="label">4.</td>
                <td className="info">
                  第２項の申込みのキャンセルについては、当社が別途定める方法によるものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第８条（当社による売買契約の解除）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  当社は売買契約を解除することができるものとします。
                </td>
              </tr>
              <tr>
                <td className="sub_num">（1）</td>
                <td className="info">会員が本規約に違反した場合</td>
              </tr>
              <tr>
                <td className="sub_num">（2）</td>
                <td className="info">
                  商品が品切れとなり、予定される時間までに容易に商品が準備できない場合
                </td>
              </tr>
              <tr>
                <td className="sub_num">（3）</td>
                <td className="info">
                  その他商品を用意できない緊急事態が発生した場合
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  前項の規定に関らず、本サービスの利用に関して会員による不正行為等があった場合、当社は売買契約を取消し若しくは解除、その他適切な措置をとることができるものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第９条（支払価格及び方法）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  会員が商品の注文を行い、当社にお支払いいただく価格は、商品代金及び消費税の合計額となります。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  会員によるお支払については、本サービス内クレジット決済のほか、現金その他当社の指定する方法により、商品を受け取る店舗にてお支払いいただきます。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１０条（商品の返品等）</ArticleHeader>
        <ArticleContent>
          <Text>
            会員は、当社の提供する商品が飲食物であるという特性に鑑み、商品の不良、商品違い、その他当社が相当と認める場合を除き、商品を返品することができないものとします。また、商品の返品、不良な商品の交換又は交換が不可能な場合の契約の解除は、会員が商品を受領した後［２］時間以内、かつ、当社が発行した領収書を提示して申し出た場合に限り行うことができるものとします。
          </Text>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>第１１条（禁止事項）</ArticleHeader>
        <ArticleContent>
          <Text>会員が以下の行為を行うことは禁止されます。</Text>
        </ArticleContent>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="num">（1）</td>
                <td className="info">
                  会員登録の申込み又は変更の際に実際と異なる登録内容を申請する行為
                </td>
              </tr>
              <tr>
                <td className="num">（2）</td>
                <td className="info">
                  商品の受取りの意思のない注文、過剰な注文、本サービスの運営を妨げる行為、その他当社による本サービスの提供に支障をきたす恐れのある行為
                </td>
              </tr>
              <tr>
                <td className="num">（3）</td>
                <td className="info">
                  メールアドレス又はパスワードを不正に使用する行為
                </td>
              </tr>
              <tr>
                <td className="num">（4）</td>
                <td className="info">
                  他の会員、第三者もしくは当社に迷惑、不利益もしくは損害を与える行為、又はそれらのおそれのある行為
                </td>
              </tr>
              <tr>
                <td className="num">（5）</td>
                <td className="info">
                  他の会員、第三者若しくは当社の権利（知的財産権及びプライバシーその他の権利を含む。）を侵害する行為、又はそれらのおそれのある行為
                </td>
              </tr>
              <tr>
                <td className="num">（6）</td>
                <td className="info">
                  公序良俗に反する行為、法令に違反する行為、又はそれらのおそれのある行為
                </td>
              </tr>
              <tr>
                <td className="num">（7）</td>
                <td className="info">その他、当社が不適当と判断する行為</td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１２条（遵守事項等）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  会員は、当社に対して、自らが反社会的勢力（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、社会運動標ぼうゴロ、政治活動標ぼうゴロ、
                  特殊知能暴力集団その他一般に反社会的勢力と認識されるものをいいます。）に該当しないことを表明し、保証します。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  会員は、自ら注文した商品について、店舗及び時間を遵守して受け取り、商品代金を支払うものとします。商品の受け取りは、当社が当サイトに規定した方法によって行うものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  会員は、商品を注文する際には、一時的に大量の注文をする等の当社の通常業務の妨げになる注文を行わないものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１３条（著作権等）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  会員は、当社の許諾を得ないで、本サービスに関して当社から提供されるいかなる情報又は表現についても、著作権法で認められる範囲を超えて使用することができないものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  本条の規定に違反して当社、権利者又は第三者との間で問題が生じた場合、会員は自己の責任と費用においてその問題を解決するとともに、当社に何らの損害を与えないものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>
          第１４条（メールアドレス及びパスワードの管理）
        </ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  会員は、会員自身で登録したメールアドレス及びパスワードの管理責任を負うものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  会員は、メールアドレス及びパスワードを第三者に譲渡、貸与、開示してはならないものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  会員は、メールアドレス又はパスワードにつき、使用上の過誤、不適切な管理、第三者による使用などにより生じる損害につき、自ら責任を負うものとします。
                </td>
              </tr>
              <tr>
                <td className="label">4.</td>
                <td className="info">
                  会員は、メールアドレス又はパスワードが第三者によって不正に使用されていることが判明した場合には、直ちに当社に連絡するものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１５条（会員情報の取扱い）</ArticleHeader>
        <ArticleContent>
          <Text>
            会員情報については、当社及び当社の委託を受けたunerryが取り扱うものとし、以下に定める「プライバシーポリシー」によるものとし、会員は当該個人情報の取扱いに関する定めに従って当社及びunerryが会員情報を取扱うことについて同意するものとします。
            本サービスの利用に関連して当社又はunerryが知り得た会員の情報について、当社及びunerryは以下の各号に該当する場合を除き、第三者に開示又は提供しないものとします。
          </Text>
        </ArticleContent>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="num">（1）</td>
                <td className="info">
                  当社に提供した情報、データ等を、特定の個人を識別できない形式に加工した統計情報を当社又は第三者に提供する場合
                </td>
              </tr>
              <tr>
                <td className="num">（2）</td>
                <td className="info">
                  本サービスの提供に必要な場合（当社に対する提供に限る。）
                </td>
              </tr>
              <tr>
                <td className="num">（3）</td>
                <td className="info">
                  本規約の違反が合理的に疑われる場合に、調査をする必要がある場合
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１６条（情報の管理）</ArticleHeader>
        <ArticleContent>
          <Text>
            当社は、当社が提供するサイト上に会員が発信したコメントその他の情報について、次の各号の一つにでも該当する場合には、当社の判断によって、会員に断りなくこれを削除することができるものとします。
          </Text>
        </ArticleContent>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="num">（1）</td>
                <td className="info">
                  当該情報が当社若しくは第三者の権利を明らかに侵害し、又は当社若しくは第三者の名誉・信用を害する行為が認められる場合
                </td>
              </tr>
              <tr>
                <td className="num">（2）</td>
                <td className="info">
                  当該情報が第三者の権利を侵害し、又は第三者の名誉・信用を害する旨の警告を当社が第三者から受け取った場合
                </td>
              </tr>
              <tr>
                <td className="num">（3）</td>
                <td className="info">
                  本規約又は適用ある法令に違反していると認められた場合
                </td>
              </tr>
              <tr>
                <td className="num">（4）</td>
                <td className="info">
                  法令上の根拠に基づき裁判所、官公庁、公的機関から削除するよう命令を受けた場合
                </td>
              </tr>
              <tr>
                <td className="num">（5）</td>
                <td className="info">
                  その他本サービスの運営にとって掲載が不適切と認められる場合
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１７条（本サービス提供の停止）</ArticleHeader>
        <ArticleContent>
          <Text>
            当社は、次の各号の１つにでも該当する場合、会員に事前に通知を行うことなく本サービスの提供の全部又は一部を停止することができるものとします。
          </Text>
        </ArticleContent>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="num">（1）</td>
                <td className="info">
                  システムの定期保守又は緊急の保守のために必要な場合
                </td>
              </tr>
              <tr>
                <td className="num">（2）</td>
                <td className="info">
                  火災、停電、第三者による妨害行為などによりシステムの運用が困難になった場合
                </td>
              </tr>
              <tr>
                <td className="num">（3）</td>
                <td className="info">
                  天災地変等により当社サービスの提供が困難になった場合
                </td>
              </tr>
              <tr>
                <td className="num">（4）</td>
                <td className="info">
                  その他、やむを得ずシステム又は本サービスの停止が必要と当社が判断した場合
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１８条（免責事項）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  当社は、会員に対して通知義務を負う場合は、会員があらかじめ登録しているメールアドレスへ通知を発信することにより、その義務を果たしたものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  当社及び当社の業務委託先であるunerryは、故意又は重過失がない限り、会員が本サービスをご利用になれなかったこと又は会員による本サービスの利用により発生した一切の損害について、いかなる責任も負わないものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  当社は、会員の登録内容に従い事務を処理することにより免責されるものとします。
                </td>
              </tr>
              <tr>
                <td className="label">4.</td>
                <td className="info">
                  当社は、会員がパスワードの変更などを行う場合、登録メールアドレスを通じて行う認証等当社指定の方法で確認を行うことにより免責されるものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第１９条（退会）</ArticleHeader>
        <ArticleContent>
          <Text>
            会員は、退会を希望する場合、当社所定の方法で当社に通知することにより退会し、会員登録を抹消することができます。退会後の会員情報の取扱いについては、第１６条の規定に従うものとします。
          </Text>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>第２０条（メールアドレスの利用について）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  当社は会員に対して、電子メール（本サービスのほか、当社の各種サービスに関連の情報、告知、運営上の事務連絡に関連する電子メールを含む。）を配信することができるものとします。電子メールには当社のサービスに関わる情報のほか、当社商品、懸賞・キャンペーン等に関する広告等が含まれる場合があります。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  当社は、メールマガジン等の配信にあたり、会員が登録したメールアドレスのみ使用するものとします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <Article>
        <ArticleHeader>第２１条（その他）</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">1.</td>
                <td className="info">
                  本サービスにかかわるお問い合わせ等については、当社の定める方法で行うものとします。
                </td>
              </tr>
              <tr>
                <td className="label">2.</td>
                <td className="info">
                  本サービスのご利用に関して、本規約により解決できない問題が生じた場合には、当社と会員との間で双方誠実に協議するものとし、これを解決するものとします。
                </td>
              </tr>
              <tr>
                <td className="label">3.</td>
                <td className="info">
                  本規約及び本サービスについては、日本国法に準拠するものとし、本サービスの利用に関して訴訟の必要が発生した場合には、東京簡易裁判所、東京地方裁判所、大分簡易裁判所又は大分地方裁判所を第一審の合意管轄裁判所といたします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>

      <FooterArea>
        <Text>以上</Text>
      </FooterArea>

      <TitleWrapper2 id="privacy_policy">
        <Title>プライバシーポリシー</Title>
      </TitleWrapper2>

      <Article>
        <ArticleHeader2>１ 取得・収集する情報について</ArticleHeader2>
        <ArticleContent2>
          <Text>
            （１）当社は、本サービスにおいて、会員登録を希望するお客様から、以下の情報（以下、「個人情報等」といいます。）を取得します。
          </Text>
          <BulletPoints>
            <p className="bullet-point">氏名</p>
            <p className="bullet-point">電話番号</p>
            <p className="bullet-point">メールアドレス</p>
            <p className="bullet-point">パスワード</p>
            <p className="bullet-point">
              その他、当社が定める申込みフォームにお客様が入力する情報
            </p>
          </BulletPoints>
          <Text>
            （２）当社は、上記に加えて、会員が本サービスを利用するに際して、以下の情報を収集します。
          </Text>
          <BulletPoints>
            <p className="bullet-point">IPアドレス</p>
            <p className="bullet-point">サイトへのアクセスログ</p>
            <p className="bullet-point">Cookie</p>
          </BulletPoints>
        </ArticleContent2>
      </Article>

      <Article2>
        <ArticleHeader>２ 個人情報等の管理について</ArticleHeader>
        <ArticleContent2>
          <Text>
            当社は、個人情報等の管理にあたり、管理責任者のもと、適切な管理を行うとともに、外部への流出防止のためにセキュリティ上最大限の注意を払います。外部からの不正なアクセス等に対しては、商業上適正かつ合理的なレベルのセキュリティ対策を実施しています。本サービスの提供にあたり、個人情報等の取扱を外部に委託することがありますが、委託先は当社が個人情報等を適切に取り扱っていると認める委託先に限定するとともに、委託先についても、個人情報等の管理につき適切な管理を実施させていきます。
          </Text>
        </ArticleContent2>
      </Article2>

      <Article2>
        <ArticleHeader>３ 個人情報等の利用等について</ArticleHeader>
        <ArticleContent2>
          <Text>
            当社は、個人情報等を取り扱うにあたり、その利用目的を可能な限り特定します。また、個人情報等を取得した場合は、適正な手段で取得し、予めその利用目的を公表している場合を除き、速やかに、その利用目的を、ご本人に通知し、又は公表します。
          </Text>
          <Text>
            当社は、会員より受領した個人情報等を以下の目的で使用します。
          </Text>
        </ArticleContent2>
        <BulletPoints>
          <p className="txt_offset">
            （１）本サービスの提供（会員との連絡を含む。）
          </p>
          <p className="txt_offset">
            （２）ご注文いただいた商品の授受及びお支払管理、アフターサービス等
          </p>
          <p className="txt_offset">
            （３）本サービス及びジョイフルの提供するサービスについてのご案内・広告
          </p>
          <p className="txt_offset">（４）懸賞及びキャンペーン等の実施</p>
          <p className="txt_offset">
            （５）前各号のほか、個人を特定することができない形に加工したうえ、飲食事業に関する立地・物件の調査、衛生管理、市場調査その他の調査研究その他、経営分析のための統計数値策作成及び分析結果の利用
          </p>
          <p className="txt_offset">
            （６）個人情報保護法に基づく開示請求等への対応、並びに個人情報の取り扱いに関する監視及び監査
          </p>
          <p className="txt_offset">
            （７）前各号の事項に関する、株式会社unerryとの共同利用（株式会社unerryが個人情報等を受領した場合、前各号に準じる範囲で個人情報等を利用するものとします。）
          </p>
        </BulletPoints>
      </Article2>

      <Article2>
        <ArticleHeader>４ 個人情報等の提供等について</ArticleHeader>
        <ArticleContent2>
          <Text>
            当社は、法令により例外として扱うことが認められている場合を除き、あらかじめご本人の同意を得ることなく、個人情報等を第三者に提供することはありません。ただし、法令による場合、又は裁判所、警察などの公的機関から開示を求められた場合には、ご本人の同意なく個人情報を提供することがあります。
          </Text>
        </ArticleContent2>
      </Article2>

      <Article2>
        <ArticleHeader>５ 個人情報の開示、訂正等について</ArticleHeader>
        <ArticleContent2>
          <Text>
            当社は、個人情報等のうち個人情報につき、ご本人又は代理人からの開示、訂正等（訂正、追加、削除、利用停止、消去又は第三者への提供の停止をいい、以下も同様とします。）を求められたときは、法令に基づきその求めに対応いたします。
          </Text>
        </ArticleContent2>
      </Article2>

      <Article2>
        <ArticleHeader>６ 個人情報の相談について</ArticleHeader>
        <ArticleContent2>
          <Text>
            当社は、個人情報等の取扱いにかかわるお客様からのご連絡につき、適切かつ迅速な処理に取り組み、そのための社内体制の整備に努めます。個人情報については、以下にお問い合わせください。
          </Text>
          <p className="txt">
            [株式会社ジョイフル 個人情報等相談窓口]
            <br />
            Tel.097-551-7131(代表) Fax.097-551-7369
            <br />
            受付時間：月曜〜金曜 9時30分〜18時30分
          </p>
        </ArticleContent2>
      </Article2>

      <Article2>
        <ArticleHeader>７ 利用停止等</ArticleHeader>
        <ArticleContent2>
          <Text>
            保有個人データについて、利用目的の通知、開示、訂正、追加、削除、利用停止等の求めにつきましては、下記の手続によりお申し出ください。
          </Text>
          <BulletPoints>
            <p className="txt_offset">
              （１）当社所定の請求書をご使用いただき、郵送（簡易書留で）にて下記申出先へ申出くださいますようお願いします。また、使用する封筒は、外から中が透けて見えない封筒をお使いください。
              <br />
              <span className="alt_txt">
                申出先：〒870-0141 大分県大分市三川新町一丁目1番45号
              </span>
            </p>
            <p className="txt_offset">
              （２）
              当社所定の請求書の請求は、上記個人情報等相談窓口への問合せにて承ります。
            </p>
            <p className="txt_offset">
              （３）ご本人であることの確認をするため、現住所の記載がある運転免許証、健康保険証、住民票、その他これらに準ずる公的書類のいずれか一つのコピーを同封して申出ください。その他、上記お客様相談室にてご連絡した方法を遵守してください。
            </p>
            <p className="txt_offset">
              （４）
              請求者の住所、氏名の宛先を記入した返信用の封筒を同封してください。
            </p>
          </BulletPoints>
        </ArticleContent2>
      </Article2>

      <ButtonWrapper>
        {query && query === "close" ? (
          <Button btnStyle="secondary" text="閉じる" onClick={window.close} />
        ) : (
          <BackToTopPageButton />
        )}
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px 61px;
  color: #333333;
`;

const TitleWrapper = styled.div`
  padding: 73px 0 5px 0;
  display: flex;
  justify-content: center;
`;

const TitleWrapper2 = styled.div`
  padding: 73px 0 28px 0;
  display: flex;
  justify-content: center;
`;

const Title = styled.p`
  font-size: 20px;
  font-weight: 600;
  line-height: 1em;
  font-family: "Hiragino Sans";
`;

const Caption = styled.p`
  font-weight: 200;
  margin: 30px 0;
  text-align: left;
  font-size: 14px;
  font-family: "Hiragino Sans";
  line-height: 21px;
`;

const Article = styled.div`
  margin-top: 10px;
`;

const Article2 = styled.div`
  margin-top: 34px;
`;

const ArticleHeader = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 26px;
  border-bottom: 1px solid #000;
  margin-bottom: 10px;
  font-family: "Hiragino Sans";
`;

const ArticleHeader2 = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 26px;
  border-bottom: 1px solid #000;
  font-family: "Hiragino Sans";
`;

const ArticleContent = styled.div`
  line-height: 21px;
  font-size: 14px;
  font-weight: 200;
  margin-top: 20px;
  .txt {
    padding: 20px 20px 0 0;
  }
`;

const Text = styled.p`
  font-family: "Hiragino Sans";
  line-height: 21px;
`;

const ArticleContent2 = styled.div`
  line-height: 21px;
  font-size: 14px;
  font-weight: 200;
  margin: 10px 0 0px;
  .txt {
    padding: 15px 20px 0 0;
    font-family: "Hiragino Sans";
  }
`;

const ArticleTableContent = styled.div`
  table {
    line-height: 21px;
    font-size: 14px;
    font-weight: 200;
    border-collapse: separate;
    border-spacing: 0 8px;

    .label {
      vertical-align: text-top;
      padding-right: 5px;
      font-family: "Hiragino Sans";
    }
    .info {
      line-height: 21px;
      font-family: "Hiragino Sans";
    }
    .num {
      padding: 0 15px 0 10px;
      vertical-align: top;
      text-align: left;
      display: table-cell;
      white-space: nowrap;
      font-family: "Hiragino Sans";
    }
    .sub_num {
      padding: 0 15px 0 10px;
    }
  }
`;

const BulletPoints = styled.div`
  padding: 0 20px 0 15px;
  .bullet-point {
    position: relative;
    padding-left: 19px;
    line-height: 26px;
    font-family: "Hiragino Sans";
    &:before {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      background: #333333;
      border-radius: 100%;
      left: 0px;
      top: 7px;
    }
  }

  .txt_offset {
    text-indent: -3em;
    padding-left: 2.3em;
    font-size: 14px;
    font-weight: 200;
    font-family: "Hiragino Sans";
  }
  .alt_txt {
    padding: 10px 0;
    font-family: "Hiragino Sans";
  }
`;

const FooterArea = styled.div`
  text-align: right;
  margin: 68px 0 46px;
  font-size: 14px;
  font-weight: 200;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 600;
  }
`;
